import React from "react";

import {
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import CreateLookUpTableForm from "./forms/CreateLookUpTableForm";
import { FORM_TYPE_ADD } from "../../../_helpers/constants";

export default function CreateLookupTable() {
     return (
          <>
               <MainLeftTitle title="Create Lookup Table"></MainLeftTitle>
               <CreateLookUpTableForm type={FORM_TYPE_ADD} />
          </>
     );
}
